import React from "react";
import { MediaBaseUrl } from "../../../../../../../actions/api";

const NetworkTab = ({ network, selectedNetworkId, updatedSelectedNetwork }) => {
    const { networkName, networkId, networkCode } = network;

    return <li className={`${selectedNetworkId == networkId ? "active" : ""} cursor-pointer position-relative ob-source-tile ob-tile-${String(networkCode).toLowerCase()}`} onClick={() => updatedSelectedNetwork(networkId)}>
        <img src={`${MediaBaseUrl}square-icons/${networkId == 1 ? 'twitterX' : networkCode}.svg`} alt={networkName} className="img-fluid ob-source-tile-icon" />
        <span>{networkName}</span>
    </li>
}

export default NetworkTab;
